import { Location } from 'vue-router';

export interface IMenuItem {
  name: string;
  icon: string;
  iconUnread?: string;
  key: string;
  to?: Location;
  isActive?: boolean;
  isLink?: boolean;
  href?: string;
  route?: string[];
  visible?: boolean;
  action?: () => void;
  tooltip?: string;
  unreadCountLabel?: string;
}

export interface IMoreMenuItem extends IMenuItem {
  nameOpened: string;
  iconOpened: string;
}

export const menuItemKeys: Record<string, string> = Object.freeze({
  FEED: 'feed',
  ACADEMY: 'academy',
  SALES_INDEX: 'salesIndex',
  JOBS: 'jobs',
  NOTIFICATIONS: 'notifications',
  SELLER_PORTFOLIO: 'sellerPortfolio',
  MORE: 'more',
  LOG_IN: 'logIn',
  SALARIES: 'Salaries',
});

export const menuItems: Record<string, IMenuItem | IMoreMenuItem> = Object.freeze({
  [menuItemKeys.SELLER_PORTFOLIO]: {
    name: 'Portfolio',
    icon: 'briefcase',
    key: menuItemKeys.SELLER_PORTFOLIO,
  },
  [menuItemKeys.FEED]: {
    name: 'Feed',
    icon: 'home',
    key: menuItemKeys.FEED,
  },
  [menuItemKeys.FEED_LOGGED]: {
    name: 'My Feed',
    icon: 'home',
    key: menuItemKeys.FEED,
  },
  [menuItemKeys.ACADEMY]: {
    name: 'Academy',
    icon: 'book',
    key: menuItemKeys.ACADEMY,
  },
  [menuItemKeys.SALES_INDEX]: {
    name: 'Index',
    icon: 'chart',
    key: menuItemKeys.SALES_INDEX,
  },
  [menuItemKeys.JOBS]: {
    name: 'Jobs',
    icon: 'jobs',
    iconUnread: 'jobs-unread',
    key: menuItemKeys.JOBS,
  },
  [menuItemKeys.NOTIFICATIONS]: {
    name: 'Activity',
    icon: 'bell',
    iconUnread: 'bell-unread',
    key: menuItemKeys.NOTIFICATIONS,
  },
  [menuItemKeys.MORE]: {
    name: 'More',
    nameOpened: 'Close',
    icon: 'more',
    iconOpened: 'close',
    key: menuItemKeys.MORE,
  },
  [menuItemKeys.LOG_IN]: {
    name: 'Log In',
    icon: 'profile',
    key: menuItemKeys.LOG_IN,
  },
  [menuItemKeys.SALARIES]: {
    name: 'Salaries',
    icon: 'salaries',
    key: menuItemKeys.SALARIES,
  },
});
